import { gql } from '@apollo/client';

export const CREATE_READING_MATERIAL = gql`
mutation CreateReadingMaterial($input: CreateReadingMaterialInput) {
    createReadingMaterial(input: $input) {
        data {
            reading_material {
                created_at
                description
                id
                name
                pdf
                updated_at
                video_id
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;
export const UPDATE_READING_MATERIAL = gql`
mutation UpdateReadingMaterial($materialId:UUID!,$input: CreateReadingMaterialInput!) {
    updateReadingMaterial(materialId: $materialId, input: $input) {
        data {
            reading_material {
                created_at
                description
                id
                name
                pdf
                updated_at
                video_id
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;

export const DELETE_READING_MATERIAL= gql`
 mutation DeleteReadingMaterial($materialId:UUID!) {
    deleteReadingMaterial(materialId: $materialId) {
        error
        data {
            message
        }
    }
}

`;